export default __webpack_public_path__ + "static/media/exclamation-full.14778811.svg";